import React, { useState } from 'react'
import { compose } from 'redux'
import PropTypes from 'prop-types'
import Link from 'components/link'
import Tooltip from 'components/tooltip'
import PoweredBy from 'components/powered-by'
import Font from '@cred/react-font'
import { Testable } from '@cred/react-testable'
import { Link as NoAnalyticsLink } from '@cred/react-link'
import { collapsibleClick } from '@cred/react-analytics/events'
import { withSnowplowContexts } from '@cred/react-analytics/SnowplowContextManager'
import { Disclosure } from '@cred/react-disclosures-sdk'
import { Collapse } from 'react-collapse'
import { onlyMobile, exceptMobile } from 'common/visibility'
import config from 'config'
import styles from './styles.scss'
import Disclosures from '../disclosures'

const getFontColor = (theme) => {
  switch (theme) {
    case 'insider':
      return 'accent'
    default:
      return 'secondary'
  }
}

const RateWidgetFooter = ({ theme, footerDisclosure, trackSnowplowEvent }) => {
  const [isOpen, setOpen] = useState(false),
    partners = ['thebalance1', 'investopedia1', 'yahoo1', 'insider'],
    hidePartners = ['thebalance1', 'investopedia1', 'homes1'],
    linkCss = partners.includes(theme) ? theme : '',
    showDisclosure = !hidePartners.includes(theme),
    iconClass = isOpen ? 'icon-chevron-up' : 'icon-chevron-down'

  const toggleLenderList = () => {
    setOpen(!isOpen)

    trackSnowplowEvent(collapsibleClick, {
      text: 'Disclosures',
      action: isOpen ? 'collapse' : 'expand',
    })
  }

  const fontColor = getFontColor(theme)

  return (
    <>
      <Testable className={`${styles.container} mt-24`} testId="footer">
        <div className={styles.links}>
          <div className={styles.row}>
            <Link
              rel="nofollow"
              className={`${styles[linkCss]} ${styles.link}`}
              blank
              href={`${config.credibleRoot}/terms`}
              analyticsOptions={{ text: 'Terms' }}
            >
              <Font type="bodySmall" color={fontColor}>
                Terms
              </Font>
            </Link>
            <Link
              rel="nofollow"
              className={`${styles[linkCss]} ${styles.link}`}
              blank
              href={`${config.credibleRoot}/privacy`}
              analyticsOptions={{ text: 'Privacy Policy' }}
            >
              <Font type="bodySmall" color={fontColor}>
                Privacy Policy
              </Font>
            </Link>
          </div>
          <div className={styles.row}>
            {showDisclosure && (
              <Link className={`${styles[linkCss]} ${styles.link}`}>
                <Tooltip
                  analyticsOptions={{ contentSubject: 'Advertiser Disclosure' }}
                  contentProps={{ type: 'disclaimer', color: 'lighter' }}
                  triggerProps={{ type: 'bodySmall', color: fontColor }}
                  placement="top"
                  triggerContent="Advertiser Disclosure"
                >
                  <Font type="disclaimer" color="lighter" className={styles.footerDisclosure}>
                    <Disclosure required={false} slug={footerDisclosure} />
                  </Font>
                </Tooltip>
              </Link>
            )}
            <NoAnalyticsLink
              className={styles[linkCss]}
              data-for="disclosures"
              onClick={toggleLenderList}
            >
              <Font type="bodySmall" color={fontColor}>
                Disclosures <span className={`cred-icon ${iconClass}`} />
              </Font>
            </NoAnalyticsLink>
          </div>
        </div>
        <PoweredBy className={exceptMobile} useFontAttrs />
      </Testable>

      <Collapse isOpened={isOpen}>
        <Disclosures />
      </Collapse>
      <PoweredBy className={`${onlyMobile} mt-24 align-center`} useFontAttrs />
    </>
  )
}

RateWidgetFooter.propTypes = {
  theme: PropTypes.string,
  footerDisclosure: PropTypes.string,
  trackSnowplowEvent: PropTypes.func.isRequired,
}
RateWidgetFooter.defaultProps = {
  footerDisclosure: 'partners-widgets.advertiser-disclaimer.default',
}

export { RateWidgetFooter }

export default compose(withSnowplowContexts)(RateWidgetFooter)
